// Блокировка скролла

const ios = App.H.is('.ios');
let scroll = 0;

export function lock() {
    scroll = App.W.scrollTop();

    const scrollTop = App.W.scrollTop();

    App.H.addClass('_noscroll').data('scroll', scrollTop);
    App.H.css({'padding-right': scrollWidth()});

    /*if (ios) {
        const h = App.W.height();
        App.B.height(h + 100);
    }*/
}

export function unlock() {
    const scrollTop = App.H.data('scroll');

    App.H.removeClass('_noscroll');
    $('html, body').animate({ scrollTop: scrollTop }, 1);

    App.H.css({
        'padding-right': 0
    });

    if (ios) {
        App.B.height('');
        App.B.scrollTop(scroll);
    }
}

/* Возвращает ширину скролла */
export function scrollWidth() {
    let div = $('<div>').css({
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "100px",
        height: "100px",
        visibility: "hidden",
        overflow: "scroll"
    });

    $('body').eq(0).append(div);
    let width = div.get(0).offsetWidth - div.get(0).clientWidth;
    div.remove();
    return width;
}


// WEBPACK FOOTER //
// ./_src/js/modules/LockScroll.js